import { ApplyCouponResponse } from "../../../hooks/Promotions/applyPromotion";
import { customerApiBaseUrl } from "../../../native/nativeMode";
import HttpGlobal from "../Global/HttpGlobal.class";
import CouponsRequest, { CouponsRemove, CouponsQuote } from "./Request/CouponsRequest";
import CouponsCheckResponse from "./Response/CouponsCheck.response";
import { NativeCouponViewI } from "./Response/NativeCoupon.response";

export default class HttpCouponsRepository extends HttpGlobal {
  private readonly API_URL_PROMO:
    | string
    | undefined = `${process.env.REACT_APP_CUSTOMER_APP_URL}api/promo`;

  private readonly API_URL_COUPON:
    | string
    | undefined = `${process.env.REACT_APP_CUSTOMER_APP_URL}api/coupon`;

  downloadConditionPDF = async (): Promise<string> => {
    const response: string = await this.generalGet(
      `${this.API_URL_PROMO}-conditions/download/${this.leadId}`
    );
    return response;
  };

  checkPromotionalCode = async ({
    promotionalCode,
    yearlyPrice,
  }: CouponsRequest): Promise<CouponsCheckResponse> => {
    const response: CouponsCheckResponse = await this.generalPost({
      url: `${this.API_URL_PROMO}/check/${this.leadId}`,
      dataRequest: {
        promotional_code: promotionalCode,
        yearly_price: yearlyPrice,
      },
    });
    return response;
  };

  removeCoupon = async ({ promotionalCode }: CouponsRemove): Promise<void> => {
    await this.generalPost({
      url: `${this.API_URL_PROMO}/remove/${this.leadId}`,
      dataRequest: { promotional_code: promotionalCode },
    });
  };

  applyCoupon = async ({ promotionalCode }: CouponsRemove): Promise<void> => {
    await this.generalPost({
      url: `${this.API_URL_PROMO}/apply/${this.leadId}`,
      dataRequest: { promotional_code: promotionalCode },
    });
  };

  applyCouponOrganic = async ({ promotionalCode }: CouponsRemove) => {
    const response: ApplyCouponResponse = await this.generalPost({
      url: `${this.API_URL_COUPON}/apply`,
      dataRequest: { code: promotionalCode, leadId: this.leadId },
    });
    return response;
  };

  applyCouponQuote = async ({ code, leadId }: CouponsQuote) => {
    await this.generalPost({
      url: `${this.API_URL_COUPON}/quote/apply`,
      dataRequest: { code: code, leadId: leadId }
    })
  }

  // Native: el cupón del lead vive en ms-agl y va por el gateway con la sesión
  // del lead (el /api/promo del monolito no conoce al lead native). Errores con
  // el código de ms-agl en `message` (COUPON_NOT_FOUND, COUPON_EXPIRED…).
  nativeCoupon = async (): Promise<NativeCouponViewI> =>
    this.generalGet(this.nativeCouponUrl());

  applyNativeCoupon = async (code: string): Promise<NativeCouponViewI> =>
    this.generalPut({ url: this.nativeCouponUrl(), dataRequest: { code } });

  removeNativeCoupon = async (): Promise<NativeCouponViewI> =>
    this.generalDelete({ url: this.nativeCouponUrl() });

  private nativeCouponUrl = () =>
    `${customerApiBaseUrl()}/customer/leads/${this.leadId}/coupon`;
}
